export default __webpack_public_path__ + "static/media/Belt of the Wicked.bff19ff7.jpg";